/**
 * Everything the guest app shows that the server does not provide yet. Each export is a
 * stand-in for a real API field or call; replace it there and delete it here. Nothing in
 * this file reaches the server.
 */

/** MOCK: there is no "call a waiter" API, and nowhere for staff to receive the call. */
export const mockCallWaiter = () =>
  new Promise((resolve) => setTimeout(resolve, 400));
